import { DATASETS } from '../../../Components/Constants';
import { Items, Section } from '../../../types';

// SearchBar tags
export const tagMapping = (item: Items) => {
  const tooltipMappings = {
    [DATASETS.DISEASES]: item.name + ', ' + item.diseaseUMLSCUI,
    [DATASETS.GENES]: item.symbol + ', ' + item.description,
    [DATASETS.VARIANTS]: item.strID + ', ' + item.geneSymbol,
    [DATASETS.CHEMICALS]: item.chemPrefName + ', ' + item.chemID,
  };
  const toolTip = tooltipMappings[item.dataset];

  const textContentMappings = {
    [DATASETS.DISEASES]: 'Name: ' + item.name + ', ' + 'CUI: ' + item.diseaseUMLSCUI,
    [DATASETS.GENES]: `Symbol: ${item.symbol}, ${item.description ? 'Description:' + item.description + ',' : ''} EntrezId: ${item.ncbiID}`,
    [DATASETS.VARIANTS]: 'SNPdb: ' + item.strID + ', ' + 'Gene Symbol: ' + item.geneSymbol,
    [DATASETS.CHEMICALS]: 'Name: ' + item.chemPrefName + ', ID: ' + item.chemID,
  };
  const textContent = textContentMappings[item.dataset];

  return {
    tooltip: toolTip,
    text: textContent,
  };
};

// SearchBar items show
export const handleSearchItems = (searchItems, data) => {
  const sections: Section[] = [];

  if (searchItems.length === 0) {
    Object.entries({
      [DATASETS.DISEASES]: data.diseases,
      [DATASETS.GENES]: data.genes,
      [DATASETS.VARIANTS]: data.variants,
      [DATASETS.CHEMICALS]: data.chemicals,
    }).forEach(([title, items]) => {
      if (items?.length > 0) sections.push({ title, data: items });
    });
    return sections;
  }

  const keyMap = {
    diseaseID: DATASETS.DISEASES,
    geneID: DATASETS.GENES,
    strID: DATASETS.VARIANTS,
    chemID: DATASETS.CHEMICALS,
  };

  const matchKey = Object.keys(searchItems[0]).find(key => keyMap[key]) as string;
  const sectionTitle = keyMap[matchKey];

  if (sectionTitle && data[sectionTitle.toLowerCase()]?.length > 0) {
    sections.push({ title: sectionTitle, data: data[sectionTitle.toLowerCase()] });
  }

  return sections;
};

// SectionItem items naming
// Name
export const formatStrName = (item: Items) => {
  switch (item.dataset) {
    case DATASETS.DISEASES:
      return 'Name: ' + item.name + ', CUI: ' + item.id;
    case DATASETS.GENES:
      return 'Symbol: ' + item.symbol + ', Description: ' + item.description + ', EntrezId: ' + item.ncbiID;
    case DATASETS.VARIANTS:
      return 'SNPdb id: ' + item.strID + ', Gene Symbol: ' + item.geneSymbol;
    case DATASETS.CHEMICALS:
      return 'Name: ' + item.chemPrefName + ', ID: ' + item.chemID;
    default:
      break;
  }
};

// Count
export const formatStrCount = (item: Items) => {
  switch (item.dataset) {
    case DATASETS.DISEASES:
      return (
        'N. genes: ' +
        item.numGenesAssociatedToDisease_ALL +
        ', N. snps: ' +
        item.numVariantsAssociatedToDisease_ALL
      );
    case DATASETS.GENES:
      return (
        'N. diseases: ' +
        item.numDiseasesAssociatedToGene_ALL +
        ', N. snps: ' +
        item.numVariantsAssociatedToGene_ALL
      );
    case DATASETS.VARIANTS:
      return 'N. diseases: ' + item.numDiseasesAssociatedToVariant_ALL;
    case DATASETS.CHEMICALS:
      return 'N. PMIDS: ' + item.chemNumPublications;
    default:
      break;
  }
};

// Match
export const formatStrMatch = (item: Items) => {
  let match = 'Match: ';
  if (item.highlightFields && item.highlightFields[1]) {
    match += item.highlightFields[1].replaceAll('<em>', '').replaceAll('</em>', '');
  } else {
    match += 'No match information available';
  }
  return match;
};
